/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, FormControl, MenuItem, Select } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
  PortletToolbar,
} from 'components';

const TopChart = ({ meters }) => {
  const [top, setTop] = useState(10);

  // Ordenar y seleccionar los datos del top
  const dataLabels = meters
    .sort((a, b) => {
      const valueA = parseFloat(
        ((a.consumes && a.consumes.total) || '').replace(/,/g, '') || 0
      );
      const valueB = parseFloat(
        ((b.consumes && b.consumes.total) || '').replace(/,/g, '') || 0
      );
      return valueB - valueA;
    })
    .slice(0, top)
    .map((item) => ({
      name: item.name,
      value:
        item.consumes && item.consumes.total
          ? parseFloat(item.consumes.total.replace(/,/g, ''))
          : 0,
    }));

  // Crear etiquetas y valores para el gráfico
  const names = dataLabels.map((item) => item.name); // Etiquetas para el eje X
  const values = dataLabels.map((item) => item.value); // Valores para el eje Y

  function numberWithCommas(x) {
    return `${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} kWh`;
  }

  const generateColors = (num) =>
    Array.from(
      { length: num },
      () =>
        `#${Array.from({ length: 6 }, () => Math.floor(Math.random() * 16).toString(16)).join('')}`
    );

  return (
    <Portlet>
      <PortletHeader>
        <PortletLabel title="Top Consumidores" />
        {meters.length > 3 && (
          <PortletToolbar>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Select
                labelId="select-top-label"
                id="select-top"
                onChange={(e) => setTop(parseInt(e.target.value, 10))}
                value={top}
              >
                <MenuItem value={3}>Top 3</MenuItem>
                <MenuItem value={5}>Top 5</MenuItem>
                {meters.length > 5 && <MenuItem value={10}>Top 10</MenuItem>}
                <MenuItem value={meters.length}>Todos</MenuItem>
              </Select>
            </FormControl>
          </PortletToolbar>
        )}
      </PortletHeader>
      <PortletContent>
        <Box sx={{ height: 400 }}>
          <BarChart
            xAxis={[{ scaleType: 'band', data: names, dataKey: 'value' }]}
            yAxis={[{ data: names }]}
            colorMap={generateColors()}
            series={[{ data: values, label: 'Consumo', numberWithCommas }]}
            height={400}
            borderRadius={4}
          />
        </Box>
      </PortletContent>
    </Portlet>
  );
};

export default TopChart;
